// potrebne kvoli backendu .. not ideal
export enum ETrueFalse {
    TRUE = 'true',
    FALSE = 'false'
}
